const ru = {
  locale: 'ru-RU',
  messages: {
    "1周内容": "Содержание за 1 неделю",
    "1月": "Январь",
    "1月内": "В течение месяца",
    "2": "Два.",
    "2月": "Февраль",
    "3天内": "В течение 3 дней",
    "3月": "Март",
    "4S价": "4S Цены",
    "4S价格": "4S Цены",
    "4月": "Апрель",
    "5月": "Май",
    "6月": "Июнь",
    "7月": "Июль",
    "8月": "Август",
    "9月": "Сентябрь",
    "10月": "Октябрь",
    "11月": "Ноябрь",
    "12月": "Декабрь",
    "100%正品，假一赔三": "100% оригинал, за некачественный товар возмещается тройная цена",
    "123": "123.",
    "2023年上半年我们的品牌WOMALA丰富了客户未来的选择。 我们致力于成为国际认可的行业领先品牌": "В первой половине 2023 года наш бренд WOMALA расширил возможности выбора для клиентов в будущем. Мы стремимся стать международно признанным лидером в отрасли.",
    "2023年暂无业绩考核": "В 2023 году оценка эффективности отсутствует.",
    "11111": "11111",
    "111111": "111 111",
    " 订单来了": "Заказ получен",
    "(含税)": "(С налогом)",
    "(选填)公司地址": "(По желанию) адрес компании",
    "(选填)公司电话": "(По желанию) Телефон компании",
    "(选填)开户银行": "(По желанию) Банк открытия счета",
    "(选填)请输入公司地址": "(По желанию) Введите адрес компании",
    "(选填)请输入公司电话": "(По желанию) Введите телефон компании",
    "(选填)请输入开户银行": "(По желанию) Введите название банка",
    "(选填)请输入银行账户": "(По желанию) Введите номер банковского счета",
    "(选填)银行账户": "(По желанию) банковский счет",
    "*修改此模版下所有商品！": "* Изменить все товары в этом шаблоне!",
    "*所有新增客户挂帐额度，将默认为此金额！": "*Все новые кредитные лимиты для клиентов будут установлены по умолчанию на эту сумму!",
    "*根据客户关联的价格模版，使用对应报价模版；若没有关联则使用系统默认模版。": "*В соответствии с шаблоном цены, связанным с клиентом, будет использован соответствующий шаблон предложения; если он не связан, будет использован шаблон системы по умолчанию.",
    "APP": "APP",
    "EPC查询": "Запрос EPC",
    "ERP产品名称": "Название продукта ERP",
    "ERP产品编码": "Кодирование продуктов ERP",
    "ERP价格": "Цены ERP",
    "ERP价格￥": "Цены ERP.",
    "ERP品质": "Качество ERP",
    "ERP库存": "Инвентаризация ERP",
    "ERP开单": "ERP Создание документа",
    "ERP系统用户名错误将无法开单！": "Ошибка имени пользователя в ERP системе, создание документа невозможно!",
    "Logo图片": "Изображение логотипа",
    "OE号": "Номер OE",
    "OE号搜索": "Поиск по номеру OE",
    "OE搜索": "Поиск по номеру OE",
    "OSSCA1993年开始进入汽配行业，2000年正式注册OSSCA商标，服务全球售后市场，产品以严苛的标准，卓越的品质在 100 多个国家广泛流通。主营Audi、Benz、BMW、路虎等欧系豪华车零部件，目前涵盖 100多个产品系列，11万余种产品型号，所有 OSSCA产品均提供 12-24个月质保。我们将继续秉承专业、全面、放心的服务理念打造 OSSCA品牌，致力于成为全球汽车后市场的一站式卓越品牌。": "OSSCA начала свою деятельность в автомобильной запчасти в 1993 году, а в 2000 году официально зарегистрировала торговую марку OSSCA. Компания обслуживает глобальный рынок послепродажного обслуживания, и её продукция, соответствующая строгим стандартам и отличающаяся высоким качеством, широко распространяется в более чем 100 странах. Основная продукция включает запчасти для европейских люксовых автомобилей, таких как Audi, Benz, BMW и Land Rover. В настоящее время предлагается более 100 серий продукции и свыше 110 000 наименований. Все продукты OSSCA имеют гарантию от 12 до 24 месяцев. Мы продолжим придерживаться профессионального, полного и надежного подхода в обслуживании, чтобы создать бренд OSSCA и стремимся стать выдающимся брендом в глобальном рынке автомобильного послепродажного обслуживания.",
    "OSSCA1993年开始进入汽配行业，2000年正式注册OSSCA商标，服务全球售后市场，产品以严苛的标准，卓越的品质在 100 多个国家广泛流通。主营奥迪、奔驰、宝马、路虎等欧系豪华车零部件，目前涵盖 100多个产品系列，11万余种产品型号，所有 OSSCA产品均提供 12-24个月质保。我们将继续秉承专业、全面、放心的服务理念打造 OSSCA品牌，致力于成为全球汽车后市场的一站式卓越品牌。": "OSSCA начала свою деятельность в автомобильной запчасти в 1993 году, а в 2000 году официально зарегистрировала торговую марку OSSCA. Компания обслуживает глобальный рынок послепродажного обслуживания, и её продукция, соответствующая строгим стандартам и отличающаяся высоким качеством, широко распространяется в более чем 100 странах. Основная продукция включает запчасти для европейских люксовых автомобилей, таких как Audi, Benz, BMW и Land Rover. В настоящее время предлагается более 100 серий продукции и свыше 110 000 наименований. Все продукты OSSCA имеют гарантию от 12 до 24 месяцев. Мы продолжим придерживаться профессионального, полного и надежного подхода в обслуживании, чтобы создать бренд OSSCA и стремимся стать выдающимся брендом в глобальном рынке автомобильного послепродажного обслуживания.",
    "OSSCA：以卓越品质服务全球售后市场": "OSSCA: Обеспечение исключительного качества обслуживания на глобальном послепродажном рынке",
    "SKU数量": "Количество SKU",
    "VIN查询": "Запрос VIN",
    "VIN查询2": "Запрос VIN 2",
    "VIN码识别": "Идентификация VIN - кода",
    "Vin查询": "Запрос VIN",
    "WEB商城": "Торговый центр WEB",
    "apple": "Apple",
    "h5": "h5",
    "hello": "привет",
    "logo": "logo",
    "logo图片": "Изображение логотипа",
    "x 付款": "x Выплаты",
    "x秒后自动跳转我的订单": "Через x секунд произойдет автоматический переход к моему заказу.",
    "{name}秒后自动跳转我的订单": "Через {name} секунд произойдет автоматический переход к моему заказу",
    "《用户注册协议》": "Соглашение о регистрации пользователей",
    "《用户隐私协议》": "Соглашение о конфиденциальности пользователей",
    "一线品牌": "Первоклассный бренд",
    "万": "десять тысяч",
    "上下架": "Размещение на продажу и Снятие с продажи",
    "上下架编辑": "Редактировать Размещение на продажу и Снятие с продажи",
    "上传": "Загрузить",
    "上传公司名片": "Загрузить визитную карточку компании.",
    "上传发货凭证": "Загрузите ваучер на доставку",
    "上传图片大小必须小于2MB!": "Размер загружаемого изображения должен быть менее 2 МБ!",
    "上传图片大小必须小于 2MB!": "Размер загружаемого изображения должен быть менее 2 МБ!",
    "上传失败！": "Загрузка не удалась!",
    "上传收货凭证": "Загрузить ваучер квитанции",
    "上传清晰照片，可以自动识别并填充相关信息！": "Загрузите четкую фотографию, которая может быть автоматически распознана и заполнена соответствующей информацией!",
    "上传营业执照": "Загрузить лицензию на ведение бизнеса",
    "上传营业执照，可以自动识别并填充相关信息！": "Загрузите четкую фотографию, которая может быть автоматически распознана и заполнена соответствующей информацией!",
    "上架": "Размещение на продажу",
    "上涨": "Повышение",
    "上询列表": "Список запросов на котировки у поставщиков",
    "下单时间": "Время заказа",
    "下架": "Снятие с продажи",
    "下载": "Скачать",
    "下降": "Снижение",
    "不分享": "Не делиться",
    "不分享商品": "Не делиться товаром",
    "不删": "Не удалять",
    "不含税总价": "Общая цена без учета налогов",
    "不执行": "Не выполнять",
    "不锁": "разблокированный.",
    "专业的汽配商城": "Профессиональный магазин автозапчастей.",
    "专业的汽配查询工具": "Профессиональный инструмент для поиска автозапчастей.",
    "专注于研发和销售高性能的汽车零部件": "Специализируется на разработке и продаже высокопроизводительных автомобильных компонентов",
    "专用发票": "специальный счет-фактура",
    "专票": "специальный счет-фактура",
    "业绩考核": "оценка эффективности",
    "个人": "личный",
    "中文": "китайский",
    "丰田专区": "Тойота (округ)",
    "主组": "Главн. группа",
    "买家备注": "Замечания покупателя",
    "二级分类": "Вторичная классификация",
    "二维码登录": "вход через QR-код",
    "交易流水号": "номер транзакционного потока",
    "产品供应稳定，品类齐全，更专业的服务团队": "Стабильные поставки продукции, полный ассортимент продукции, более профессиональная команда обслуживания",
    "产品名称": "Название продукта",
    "产品编码": "Код продукта",
    "产地": "Место происхождения",
    "产地/品质名称": "Место происхождения/наименование качества",
    "产地不唯一，请先选择产地": "Место происхождения не является уникальным, пожалуйста, выберите место происхождения.",
    "人员": "Персонал",
    "人工审核": "Ручной аудит",
    "人民币": "Юань",
    "人民币大写": "Большая буква юаня",
    "仅退款": "Только возврат",
    "今日": "Сегодня",
    "仓位": "Склад",
    "仓库": "Склад",
    "付款": "Платежи",
    "付款时间": "Время оплаты",
    "以下产品已存在，是否覆盖现有产品？": "Следующие продукты уже существуют. Желаете ли вы заменить существующие продукты?",
    "以卓越品质服务全球售后市场": "Превосходное обслуживание мирового рынка запчастей",
    "件数": "Шт.",
    "价格模板(可多选)": "Шаблоны цен (множественный выбор)",
    "价格模版": "Шаблоны цен",
    "价格由低到高": "Цена от низкого к высокому",
    "价格由高到低": "Цена от высокой к низкой",
    "价格设置": "Установка цены",
    "企业微信": "Wecom",
    "企业认证": "Аутентификация предприятия",
    "会员价格": "Цены членов",
    "传动系统": "трансмиссия",
    "传扶": "передавать помощь",
    "传真": "Факс",
    "你们所有的货物在交货前都要检验吗？": "Проверяете ли вы все свои товары перед доставкой?",
    "你们的交货时间怎么样？": "Каковы сроки доставки?",
    "你们的样本政策是什么？": "Какова ваша политика в отношении образцов?",
    "你们的质量保证期是多久？": "Каков срок гарантии качества?",
    "你们能根据样品生产吗？": "Можете ли вы производить по образцам?",
    "你只可以上传jpeg、jpg、png格式!": "Вы можете загружать только форматы jpeg, jpg, png!",
    "你可以上传 JPG/PNG 文件!": "Вы можете загружать файлы JPG/PNG!",
    "你可以上传JPG/PNG文件!": "Вы можете загружать файлы JPG/PNG!",
    "使用零零汽账号登录": "Использовать нулевую учетную запись",
    "供应品牌": "Бренды поставщиков",
    "供应商": "Поставщик",
    "供应商名称": "Название поставщика",
    "供应商状态": "Статус поставщика",
    "供应商管理": "Управление поставщиками",
    "供应商类型": "Тип поставщика",
    "供应商详细地址": "Адрес поставщика",
    "俄文": "Русский язык",
    "保存": "Сохранить",
    "保险公司": "Страховая компания",
    "修改": "Изменить",
    "修改价格模版": "Изменить шаблон цены",
    "修改信息": "Изменить информацию",
    "修改公司信息": "Изменить информацию о компании",
    "修改发票": "Изменить счет - фактуру",
    "修改地址": "Изменить адрес",
    "修改成功": "Изменение успешно",
    "修改成功！": "Изменение успешно!",
    "修改标签": "Изменить этикетку",
    "修理厂": "Ремонтная мастерская",
    "偏好设置": "Настройки предпочтений",
    "催收单": "Напоминание о платеже",
    "催收文本": "Текст напоминания",
    "免费注册": "Бесплатная регистрация",
    "全选": "Выбрать все",
    "全部": "Все.",
    "全部定价商品": "Все товары с ценой",
    "公司": "Компания",
    "公司名片": "Визитная карточка компании",
    "公司名称": "Название компании",
    "公司注册城市": "Город регистрации компании",
    "公司税号": "Идентификационный номер налогоплательщика компании (ИНН)",
    "公司管理": "Управление компанией",
    "公司类型": "Тип компании",
    "公司详细地址": "Полный адрес компании",
    "公司：": "Компания",
    "共x个": "Всего x",
    "关于我们": "О нас",
    "关注微信公众号": "Подписаться на наш официальный WeChat.",
    "关联商品": "Связанные товары",
    "关闭": "закрыть",
    "其他": "Другие",
    "其他方式登录": "Другие способы входа",
    "其它照片": "Другие фотографии",
    "内贸团队": "Внутренняя торговая команда",
    "写跟进": "Написать отчёт о прогрессе",
    "冷却单元": "Модуль охлаждения",
    "冷却系统": "Система охлаждения",
    "净重": "Вес нетто",
    "减价": "Снижение цены",
    "出库数": "Количество отгруженных товаров",
    "分享": "Поделиться",
    "分享商品": "Делиться товарами",
    "分享状态": "Поделиться Статус",
    "分公司": "Филиал",
    "分类": "Категория",
    "分组": "Группировка",
    "分配": "Распределение",
    "分配单": "Заказ распределения",
    "分销商管理": "Управление дистрибьюторами",
    "切换公司": "Переключение компаний",
    "列表": "Список",
    "创建人": "Создатель",
    "创建时间": "Время создания",
    "删": "Удалить",
    "删除": "Удалить",
    "删除商品": "Удалить товар",
    "删除商品?": "Удалить товар?",
    "删除成功": "Удалить успешно",
    "删除成功！": "Удалить успешно!",
    "删除订单": "Удалить заказ",
    "删除记录": "Удалить запись",
    "制动主缸类": "класс тормозных цилиндров",
    "制动盘类": "Класс тормозных дисков",
    "制动系统": "Тормозные системы",
    "制动轮缸类": "Класс цилиндров тормозных колес",
    "制单": "Оформление",
    "制单日期": "Дата оформления",
    "刹车": "Тормоз",
    "前往处理": "Перейти к обработке",
    "功能": "функциональность",
    "加价": "Добавить цену",
    "加入时间": "Добавить время",
    "加入购物车": "Добавить в корзину",
    "加入购物车成功": "Добавить в корзину успешно",
    "助力器总成类": "Категория Сборка бустера",
    "勾选即表示同意": "Отметьте, чтобы согласиться",
    "包装员": "Упаковщик",
    "包裹": "Посылка",
    "包裹x": "Посылка x",
    "北京时间": "Пекинское время",
    "华东仓": "Склад в Восточном Китае",
    "单价": "Цена единицы товара",
    "单位地址": "Адрес единицы",
    "单号": "Номер единицы",
    "单据列表": "Список документов",
    "博士": "Доктор...",
    "卡钳带转向节总成类": "Суппорт с рулевым кулаком в сборе",
    "卡钳总成类": "Зажимы в сборе",
    "危险品": "Опасные грузы",
    "厂商": "Производитель",
    "历史记录": "История",
    "原厂OE": "Оригинальный OE",
    "原厂OE号": "Оригинальный OE",
    "原厂品质": "Оригинальное качество",
    "原厂大库": "Оригинальный склад",
    "原厂替换件": "Оригинальная заводская замена",
    "原厂订货": "Оригинальный заказ",
    "去查看": "Перейти к просмотру",
    "去看看": "Перейти к просмотру",
    "去确认": "Перейти к подтверждению",
    "去认证": "Перейти к сертификации",
    "参加广交会。": "Участвовать в Кантонской ярмарке.",
    "参数": "Параметры",
    "参考价格": "Справочная цена",
    "反馈": "Обратная связь",
    "反馈内容": "Содержание обратной связи",
    "反馈列表": "Список отзывов",
    "发": "отправка",
    "发动机": "Двигатель",
    "发动机型号": "Модель двигателя",
    "发动机查询": "Запрос двигателя",
    "发布询价": "Публикация запроса",
    "发短信": "Отправить сообщение",
    "发短信，将发送到公司管理员": "Отправить сообщение, которое будет отправлено администратору компании",
    "发票": "Счета - фактуры",
    "发票管理": "Управление счетами - фактурами",
    "发票类型": "增值税纸质普通发票（ НДС по обычным бумажным счетам-фактурам）",
    "发货": "Отправка",
    "发货信息": "Информация о доставке",
    "发货凭证": "уведомление о доставке",
    "发货单信息": "Информация о накладной",
    "发货员": "Грузоотправитель",
    "发货地址：": "Адрес отправки",
    "发货成功！": "Доставка удалась!",
    "发货时间": "Время отгрузки",
    "发送短信": "Отправить СМС",
    "取消": "Отмена",
    "取消售后": "Отмена после продажи",
    "取消时间": "Время отмены",
    "取消申请": "Отмена заявления",
    "取消申请，订单将恢复正常！": "Отменить заявку, заказ вернется в норму!",
    "变更": "Изменить",
    "变速箱": "Коробка передач",
    "变速箱类型": "Тип коробки передач",
    "可上传多张，每次1张，大小不超过15M": "Можно загрузить несколько фотографий, по одному за раз, размером не более 15M",
    "可以，我们可以根据您的样品或技术图纸进行生产。我们可以做模具和固定装置。": "Можно, мы можем производить продукцию по вашим образцам или техническим чертежам. Мы можем изготовить пресс-формы и приспособления.",
    "可以，我们接受贴牌生产。": "Можно, мы принимаем OEM производство.",
    "号码": "Номер",
    "合 计": "Всего",
    "合作意向": "Намерения к сотрудничеству",
    "合作电话": "Кооперативный телефон",
    "合计": "Всего",
    "合资车系": "Совместный автомобиль",
    "同意": "Согласен.",
    "同意/拒绝": "Согласие / отказ",
    "名称": "Имя",
    "名称/编码/OE": "Название / Код / OE",
    "否": "Нет",
    "含税": "Включая налоги",
    "含税价": "цена с учетом налогов",
    "启用": "Включить",
    "员工": "Работники",
    "和": "и",
    "品牌": "бренд",
    "品牌专区": "Торговый район",
    "品牌编号": "Номер марки",
    "品类": "Категория",
    "品类分类": "Классификация",
    "品质": "Качество",
    "品质(含税价)": "Качество (включая налоговую цену)",
    "品质/品牌": "Качество/Бренд",
    "品质质保": "Гарантия качества",
    "品质质保管理": "Управление качеством",
    "售价": "Цена продажи",
    "售后件数": "Количество штук",
    "售后单号": "Номер заказа",
    "售后原因": "Причины после продажи",
    "售后图片": "Фотографии после продажи",
    "售后数量": "Количество после продажи",
    "售后服务": "Послепродажное обслуживание",
    "售后类型": "Послепродажный тип",
    "售后详情": "Детали послепродажного обслуживания",
    "售后说明": "Послепродажное описание",
    "售后退款": "Возврат",
    "商品": "Товары",
    "商品信息": "Информация о товарах",
    "商品名称": "Название товара",
    "商品名称/商品编码": "Товарные наименования / товарные коды",
    "商品品质": "Качество товаров",
    "商品性质": "Характеристика товара",
    "商品数量": "Количество товаров",
    "商品管理": "Управление товарными запасами",
    "商品编号": "Товарный номер",
    "商品编码": "Коды товаров",
    "商品编辑成功！": "Успешное редактирование товаров!",
    "商品评价": "Отзыв о товаре",
    "商城": "Торговый центр",
    "商城审核": "Торговый аудит",
    "商城首页": "Главная страница торгового центра",
    "商家同意后，系统将退款给您": "После того, как продавец согласится, система вернет вам деньги.",
    "商家已同意": "Продавец согласился.",
    "商家已同意，钱款原路退回": "Продавец согласился вернуть деньги",
    "商家已同意，钱款原路退回！": "Продавец согласился вернуть деньги!",
    "商家已拒绝": "Продавец отказался.",
    "商家已拒绝，请联系商家协商！": "Продавец отказался, пожалуйста, свяжитесь с продавцом для обсуждения!",
    "商家操作时间": "Время действия продавца",
    "商户": "Торговцы",
    "商户名称": "Название продавца",
    "国产车系": "Отечественные автомобильные марки",
    "图片": "Изображение",
    "图片/视频": "Фото / видео",
    "图片大小不大于 2MB!": "Размер изображения не должен превышать 2MB!",
    "图片设置成功！": "Настройка изображения успешно выполнена!",
    "在线库存": "Онлайн-склад",
    "在线支付": "Онлайн-оплата",
    "地址": "Адрес",
    "地址信息": "Информация об адресе",
    "地址：": "Адрес",
    "型号": "модел",
    "城市": "город",
    "基本信息": "Основная информация",
    "基础模版": "Базовый шаблон",
    "填写地址与收货人信息": "Заполнить адрес и информацию о получателе",
    "增值税专用发票点数": "Ставка НДС для специальных счетов-фактур",
    "备注": "Примечание",
    "备注信息": "Информация о примечании",
    "复制": "Копировать",
    "复制成功！": "Копирование успешно!",
    "外地代收": "Поступления на местах",
    "外询统计": "Статистика внешних запросов",
    "外贸团队": "Группа внешней торговли",
    "大牌正品": "Оригинальное название",
    "头像": "Голова",
    "奔驰": "мерседес",
    "奔驰专区": "Мерседес (округ)",
    "奥迪": "Ауди",
    "奥迪专区": "Ауди (округ)",
    "如果有现货，我们可以提供样品，但是客户需要支付样品费和快递费。": "Мы можем предоставить образец, если есть спот, но клиент должен заплатить за образец и курьерскую доставку.",
    "姓名": "Имя",
    "威克特": "Уикетт.",
    "威可特": "Уикотт.",
    "完成率": "Показатель выполнения",
    "完成金额 (万)": "Выполненная сумма (млн.)",
    "完成金额(万)": "Выполненная сумма (млн.)",
    "官网": "Официальный сайт",
    "定价": "ценообразован",
    "定价列表": "Список цен",
    "定价规则": "Правила ценообразования",
    "宝马": "BMW",
    "宝马专区": "BMW (округ)",
    "实付金额": "Выплаченные суммы",
    "实到货款": "Фактическая стоимость",
    "实到采购款": "Фактические расходы на закупки",
    "实退": "Истинное отступление",
    "实退金额": "Фактическая сумма возмещения",
    "审核": "Проверка",
    "审核中": "В процессе проверки",
    "审核状态": "Статус аудита",
    "客户": "Клиент",
    "客户ID": "Идентификатор клиента",
    "客户名称": "Название клиента",
    "客户备注": "Примечания для клиентов",
    "客户审核待通过": "Проверка клиентов ожидается",
    "客户审核被拒绝": "Проверка клиента была отклонена.",
    "客户状态": "Статус клиента",
    "客户管理": "Управление клиентами",
    "客户类型": "Тип клиента",
    "客户详细地址": "Подробный адрес клиента",
    "客服": "Обслуживание клиентов",
    "宽": "широк.",
    "密码": "код",
    "密码登录": "Пароль для входа",
    "密码输入不一致！": "Пароль вводится непоследовательно!",
    "对账单": "Счета - фактуры",
    "导出": "Экспорт",
    "小程序": "Небольшие программы",
    "小程序商城": "Торговый центр малых программ",
    "小计": "Итого",
    "展开": "Развернуть",
    "属性": "Свойства",
    "岗位": "Должность",
    "工作时间": "Время работы",
    "工程编号": "Номер проекта",
    "已上架": "Уже на полке.",
    "已下架": "Сбежал.",
    "已关联": "Связаны",
    "已删除": "Отсутствие",
    "已发货": "Отправлено",
    "已取消": "Отменено",
    "已取消售后申请！": "Заявки на послепродажное обслуживание отменены!",
    "已取消，订单恢复正常": "Отменен, заказ вернулся в норму",
    "已同意": "Согласен",
    "已售后": "После продажи",
    "已完成": "в комплекте",
    "已成功发起售后申请，请耐心等待商家处理!": "Успешно запущена послепродажная заявка, пожалуйста, будьте терпеливы, ожидая обработки продавцом!",
    "已成功发起售后申请，请耐心等待商家处理！": "Успешно запущена послепродажная заявка, пожалуйста, будьте терпеливы, ожидая обработки продавцом!",
    "已成功发送短信": "Успешно отправлено SMS",
    "已成功批量生成催收单": "Сбор успешно произведен",
    "已成功设置审核状态": "Успешно установлен статус аудита.",
    "已报价": "Предложение получено",
    "已报价-已锁定": "Предложение - заблокировано",
    "已报价-待确认": "Предложение получено - Подтверждено",
    "已拒绝": "Отказано",
    "已拒绝，订单恢复正常": "Отказано, заказ возвращается в норму",
    "已有催收单无法生成": "Запрос не может быть создан.",
    "已添加备注": "Добавлены примечания",
    "已添加标签": "Добавлена метка",
    "已添加至购物车": "Добавлено в корзину покупок",
    "已禁用": "Запрещено",
    "已结算": "Расчеты произведены",
    "已认证": "Сертифицировано",
    "已选": "Выбранные",
    "已选个数": "Выбранное число",
    "已通过": "Принято",
    "市内代收": "Городской сбор",
    "市场": "рынк",
    "常用零件": "Часто используемые детали",
    "常规件": "Обычные детали",
    "平台": "Платформа",
    "平均": "В среднем",
    "年份": "Год",
    "广州市白云区景泰街白云大道南685号101号自编1009房": "Район Байюнь, Гуанчжоу, улица Цзинтай, улица Байюнь, Южный 685, 101, собственный номер 1009",
    "广州沃玛拉国际贸易有限公司": "Гуанчжоуская международная торговая компания",
    "广州沃玛拉国际贸易有限公司成立于2012年。公司位于中国广州，交通便利，占地面积2500多平方米。是一家专业销售沃尔沃汽车零部件的公司，主要经营沃尔沃XC系列、V系列、S系列、C系列的进口零部件，与车主、维修店、经销商、代理商、生产厂家长期合作，我们在全球市场建立了销售网络。我们以卓越的品质、一流的服务、专业负责的形象，致力于为客户带来最优质的产品和服务，成为国内外有名的汽车零部件经销商。": "Гуанчжоу Вома Ла Интернешнл Трейд Ко., Лтд была основана в 2012 году. Компания расположена в Гуанчжоу, Китай, с удобным транспортным сообщением и площадью более 2500 квадратных метров. Это компания, специализирующаяся на продаже автозапчастей Volvo, в основном занимается импортом запчастей для серий Volvo XC, V, S, C, и долгосрочно сотрудничает с владельцами автомобилей, ремонтными мастерскими, дилерами, агентами и производителями. Мы создали сеть продаж на глобальном рынке. Мы стремимся предоставить нашим клиентам самые качественные продукты и услуги с помощью отличного качества, первоклассного сервиса и профессиональной ответственности, и стать известным дилером автозапчастей внутри и за пределами страны.",
    "广州沃玛拉国际贸易有限公司成立于中国广州。": "Гуанчжоу Вомала Интернешнл Трейдинг Ко., Лтд. была основана в Гуанчжоу, Китай.",
    "广州沃玛拉零部件有限公司成立于2012年。公司位于中国广州，交通便利，占地面积2500多平方米。是一家专业销售沃尔沃汽车零部件的公司，主要经营沃尔沃XC系列、V系列、S系列、C系列的进口零部件，与车主、维修店、经销商、代理商、生产厂家长期合作，我们在全球市场建立了销售网络。我们以卓越的品质、一流的服务、专业负责的形象，致力于为客户带来最优质的产品和服务，成为国内外有名的汽车零部件经销商。": "Гуанчжоу Вома Ла Автозапчасти Ко., Лтд была основана в 2012 году. Компания расположена в Гуанчжоу, Китай, с удобным транспортным сообщением и площадью более 2500 квадратных метров. Это компания, специализирующаяся на продаже автозапчастей Volvo, в основном занимается импортом автозапчастей для серий Volvo XC, V, S, C, и долгосрочно сотрудничает с владельцами автомобилей, ремонтными мастерскими, дилерами, агентами и производителями. Мы создали сеть продаж на глобальном рынке. Мы стремимся предоставить нашим клиентам лучшие продукты и услуги с отличным качеством, первоклассным обслуживанием и профессиональной ответственностью, и стать известным дилером автозапчастей внутри и за пределами страны.",
    "序号": "Серийн номер",
    "库存": "Запасы",
    "库存价": "Стоимость запасов",
    "库存价格": "Стоимость запасов",
    "库存价格设置成功！": "Цены на склад установлены успешно!",
    "库存充足": "Запасов достаточно",
    "库存列表": "Список товарно - материальных запасов",
    "库存导入": "Импорт запасов",
    "库存数量": "Количество запасов",
    "库存数量：": "Количество запасов",
    "库存紧张": "Дефицит запасов",
    "应付单": "Кредиторская задолженность",
    "应付货款(￥)": "Кредиторская задолженность по товарам (п.)",
    "应付金额": "Кредиторская задолженность",
    "底盘": "Шасси",
    "底盘悬挂": "Подвеска шасси",
    "底盘系统": "Система шасси",
    "店长": "Директор.",
    "开具发票": "Оформление счетов",
    "开单": "Оформление счетов",
    "开单成功": "Счет успешно",
    "开始扩大业务范围，销售宝马、奔驰、保时捷、路虎的汽车配件。": "Начать расширение сферы бизнеса, продажа автозапчастей для BMW, Mercedes, Porsche, Land Rover.",
    "开户银行": "Банк - депозитарий",
    "张女士": "Госпожа Чжан",
    "当前定价": "Текущие цены",
    "当前报价单": "Текущее предложение",
    "当前操作人": "Текущий оператор",
    "当前状态": "8待收货",
    "当前输入的模版名称已存在！": "Имя введенного шаблона уже существует!",
    "当前选中": "Текущие параметры",
    "待分配": "Подлежит распределению",
    "待发货": "Ожидание отгрузки",
    "待商家处理": "В ожидании продавца",
    "待处理": "Подлежит обработке",
    "待审核": "Подлежит рассмотрению",
    "待报价": "Предложение ожидается",
    "待报价-待认领": "Предложение ожидает получения",
    "待支付": "Подлежит оплате",
    "待收货": "Ожидаемые товары",
    "待确认": "Подлежит подтверждению",
    "待认领": "Подлежит утверждению",
    "待译码": "Код, подлежащий декодированию",
    "微信": "Микросхема",
    "微信头像": "Микросхема",
    "微信扫码上传": "Загрузка микрокода",
    "微信扫码支付": "Микросхема для оплаты",
    "微信抓单": "Микросхема.",
    "微信支付": "Микроскопические платежи",
    "微信昵称": "Микросхема",
    "忘记密码": "Забыть пароль",
    "急件": "Срочный заказ",
    "总业绩": "Общие показатели деятельности",
    "总共": "Всего",
    "总共付款": "Всего платежей",
    "总共数量": "Всего",
    "悬挂系统": "Подвеска",
    "成为博世、海拉、马瑞利授权经销商。": "Стать авторизованным дилером Bosch, Hella, Marelli.",
    "成交率": "Коэффициент оборота",
    "成交订单": "Оформление заказов",
    "成功设置计划金额": "Успешное определение суммы плана",
    "我们开始向电子商务转型，成立外贸部并创立新品牌Womala开设两家阿里巴巴网店和一个国外网站。": "Мы начинаем переходить к электронной коммерции, создаем отдел внешней торговли и основываем новый бренд Womala, открывая два магазина на Alibaba и один зарубежный сайт.",
    "我们沃玛拉的质量保证期是18个月。": "Гарантийный срок нашего товара Вомара составляет 18 месяцев.",
    "我们的产品种类丰富，涵盖了发动机零件、制动系统、悬挂系统等多个类别，满足不同客户的多样化需求。我们始终坚持质量第一的原则，严格控制产品的生产流程，确保每一件产品都达到国际标准。": "Наш ассортимент продукции богат, охватывает детали двигателя, тормозные системы, системы подвески и многие другие категории, чтобы удовлетворить разнообразные потребности различных клиентов. Мы всегда придерживаемся принципа качества номер один, строго контролируем производственный процесс продукции и гарантируем, что каждый продукт соответствует международным стандартам.",
    "我们的仓库库存已接近1000万件，成为最具优势的零部件行业之一。沃尔沃集团的供应链": "Наш складской запас приближается к 10 миллионам единиц, что делает нас одним из наиболее преуспевающих в индустрии комплектующих. Цепочка поставок группы Volvo",
    "我们的成长历程": "Наш путь роста",
    "我的": "Мой.",
    "或": "или",
    "所在区域": "Регион",
    "所在地址": "Адрес",
    "所在城市": "Город",
    "手机号": "Номер телефона",
    "手机号码": "Номер мобильного телефона",
    "手续费": "Плата за услуги",
    "打印": "Печать",
    "打印发货单": "Печать накладной",
    "打印时间": "Время печати",
    "托收": "инкассо",
    "执行": "Осуществление",
    "执行规则?": "Исполнить правила?",
    "扫描二维码支付": "Сканирование платежей по QR - коду",
    "批量上架": "Массовая посадка",
    "批量下架": "Массовая посадка",
    "批量价格模版": "Шаблоны пакетных цен",
    "批量修改价格": "Изменить цены оптом",
    "批量修改标签": "Изменить этикетку",
    "批量删除": "Удаление пакетов",
    "批量启用/禁用": "Массовое включение / отключение",
    "批量新增标签": "Дополнительные вкладки",
    "批量标签": "Массовая метка",
    "批量生成催收单": "Сбор по серийному изготовлению",
    "批量询价": "Серийный запрос",
    "投诉电话": "Жалобы по телефону",
    "折扣": "Скидка",
    "报价": "предложен",
    "报价中": "В предложении",
    "报价列表": "Список предложений",
    "报价单数": "Количество предложений",
    "报价员": "Эксперт - оферент",
    "报价品质": "Качество предложения",
    "报价回写失败": "Ошибка обратной записи предложения",
    "报价回写成功": "Написать предложение успешно",
    "报价待认领": "Предложение ожидается",
    "报价时间": "Время предложения",
    "报价模版": "Шаблоны предложений",
    "拒绝": "Отказ",
    "拒绝售后": "Отказ от продажи.",
    "拒绝理由": "Причины отказа",
    "拖拽工单图片到这里，或点击上传": "Перетащите изображение рабочего листа сюда или нажмите для загрузки",
    "拖拽新图片到框内，可替换图片重新识别": "Перетащите новое изображение в рамку, чтобы заменить изображение для повторного распознавания",
    "招商负责人-张女士": "Руководитель по привлечению инвестиций - госпожа Чжан",
    "招商负责人-杨先生": "Руководитель компании - г - н Ян",
    "挂帐并发货": "Счет и доставка",
    "挂帐支付": "Платежи по счетам",
    "挂账": "На счету",
    "挂账支付": "Платежи по счетам",
    "挂账金额": "Сумма выставленных счетов",
    "挂账金额(万)": "Сумма выставленных счетов (млн. долл. США)",
    "挂账金额已退回！": "Счет возвращен!",
    "挂账额度设置": "Установка лимита",
    "按所选日期批量生成": "Создание пакетов по выбранной дате",
    "按比例定价商品": "Пропорциональное ценообразование на товары",
    "挑选产品并加入购物车": "Выберите продукт и добавьте его в корзину.",
    "授信挂账额度": "Степень кредитоспособности",
    "授信额度": "Кредитный лимит",
    "排量": "объём",
    "排量(发动机代码)": "Объем выпуска (код двигателя)",
    "接听人": "Ответ",
    "接听时间": "Время ответа",
    "推广专区": "Пропаганда специальных районов",
    "推荐图片": "Рекомендуем фото",
    "推荐排序": "Рекомендуемая сортировка",
    "提交时间": "Дата представления",
    "提交申请": "Подача заявления",
    "提示": "Подсказка",
    "提示 ": "如需订单帮助，请发送电子邮件至",
    "搜索": "Поиск",
    "搜索零件名称": "Поиск названий деталей",
    "操作": "операцион",
    "操作人": "Оператор",
    "操作成功": "Операция прошла успешно",
    "操作成功！": "Операция удалась!",
    "操作时间": "Время работы",
    "支付宝": "Платежное сокровище",
    "支付宝扫码支付": "Оплата с помощью кода",
    "支付成功": "Оплата успешно",
    "支付方式": "Способы оплаты",
    "支付金额": "Сумма платежа",
    "支持输入负数": "Поддержка отрицательного ввода",
    "收款": "Поступления",
    "收货人": "Получатель",
    "收货人信息": "Информация о грузополучателе",
    "收货人姓名": "Имя грузополучателя",
    "收货付款": "Полученные платежи",
    "收货凭证": "Доказательства получения",
    "收货地址": "Адрес получения",
    "收货地址管理": "Управление адресами получения",
    "收货成功！": "Получил успешно!",
    "收起": "Убрать",
    "改装车系": "Модернизация",
    "放心启动": "Не беспокойтесь о запуске.",
    "放心好油": "Спокойно, масло.",
    "敞篷车": "C откидным верхом",
    "数据录入": "Ввод данных",
    "数量": "Количество",
    "数量/单位": "Количество / единица",
    "整车配件一站式解决方案 · 沃尔沃汽车零部件专家": "Комплексное решение для автозапчастей · Эксперт по запчастям для автомобилей Volvo",
    "整车配件一站式解决方案·沃尔沃汽车零部件专家": "Комплексное решение для автозапчастей · Эксперт по запчастям для автомобилей Volvo",
    "文本": "Текст",
    "新品发布": "Выпуск новой продукции",
    "新增": "Дополнительные",
    "新增发票": "Дополнительные счета - фактуры",
    "新增地址": "Дополнительный адрес",
    "新增成功！": "Добавить успех!",
    "新增标签": "Добавить метку",
    "新增模版": "Дополнительные шаблоны",
    "新建客户": "Новые клиенты",
    "无": "без",
    "无价格": "Нет цены",
    "无图": "Без диаграммы",
    "无意向": "Без намерения",
    "无替换件": "Без замены",
    "无模版": "Нет шаблонов",
    "无法生成催收单！": "Невозможно создать квитанцию!",
    "日期": "День недели",
    "易碎品": "Хрупкость",
    "是": "Да.",
    "是否移出购物车？": "Вы хотите удалить это из корзины?",
    "是的，我们在发货前有100%的测试。我们注重质量。": "Да, мы проводим 100% тестирование перед отправкой товара. Мы уделяем внимание качеству.",
    "昵称": "Прозвище",
    "显示其他属性": "Показать другие атрибуты",
    "普票": "всеобщее голосование",
    "普通发票": "Общий счет - фактура",
    "普通发票开票点数": "Число выставленных счетов - фактур",
    "普通员工": "Обычные работники",
    "智能识别": "Интеллектуальное распознавание",
    "暂不支持此支付方式": "Не поддерживается данный способ оплаты.",
    "暂无": "В без",
    "暂无发票": "Нет счета",
    "暂无发票，请添加发票": "Нет счета, пожалуйста, добавьте счет",
    "暂无地址": "Нет адреса",
    "暂无地址，新增地址": "Нет адреса, добавить адрес",
    "暂无数据": "Нет данных",
    "暂无跟进记录": "Отсутствуют последующие записи",
    "更多": "больше",
    "更新成功": "Обновление успешно",
    "更新成功！": "Обновление успешно!",
    "更新时间": "Время обновления",
    "替换件": "Замена",
    "替换家": "Замена дома",
    "最后一次询价时间": "Время последнего запроса",
    "最多3张": "Максимум 3.",
    "最多可退": "Максимальное отступление.",
    "最多可退件数": "Максимальное число подлежащих возврату",
    "最大（默认）": "Максимум (по умолчанию)",
    "最小": "Сам маленьк",
    "最新报价时间": "Время последнего предложения",
    "最近跟进人": "Последние последователи",
    "最近跟进内容": "Последнее последующее содержание",
    "有": "у",
    "有价格": "Есть цена",
    "有原盒": "Оригинальная коробка.",
    "有图": "Есть диаграммы.",
    "未关联": "Не связанные",
    "未合作原因": "Причины отсутствия сотрудничества",
    "未查询到商品信息，请前往ERP库存补充此产品编码对应的适用OE，生成商品编码后，即可进行定价！": "Без запроса информации о товаре, пожалуйста, перейдите в инвентарь ERP, чтобы дополнить этот код продукта, соответствующий применимому OE, после создания товарного кода, вы можете установить цену!",
    "未活跃天数": "Количество неактивных дней",
    "未结算": "Непогашенные обязательства",
    "未认证": "Не сертифицирован",
    "未过滤": "Без фильтрации",
    "未通过": "Не принято",
    "本期应付货款": "Кредиторская задолженность за текущий период",
    "材质": "Материалы",
    "条": "Статья",
    "来源": "Источник",
    "杨先生": "г - н Ян",
    "极致优选，国际大牌配套": "Предельное превосходство, комплектация международных брендов",
    "查看": "Посмотреть",
    "查看更多": "Узнать больше",
    "查询": "Запрос",
    "查询次数": "Количество запросов",
    "查询结果": "Результаты поиска",
    "标签": "Label",
    "标签(可多选)": "Метки (могут быть выбраны)",
    "标签名称": "Название метки",
    "标签类型": "Тип метки",
    "标签设置成功！": "Настройка метки удалась!",
    "模版名称": "Имя шаблона",
    "正常": "Нормально.",
    "比价": "Соотношение цен",
    "汇款": "Денежные переводы",
    "汽灵灵云汽配，一站式交易平台。": "Облачный дистрибутив Far Lingling, единая торговая платформа.",
    "汽灵灵自2018年成立以来，便专注于为汽车后市场提供供应链产业协同服务。致力于打造高效供应链服务平台，实现资源的优化配置与信息共享，其服务内容涵盖了汽车配件的采购、销售、物流配送、技术支持以及平台运营等多个环节，为汽配行业提供全方位、一站式的供应链解决方案。": "С момента своего основания в 2018 году компания концентрируется на предоставлении совместных услуг по цепочке поставок для автомобильного рынка. Стремитесь создать эффективную платформу обслуживания цепочки поставок, реализовать оптимальное распределение ресурсов и обмен информацией, ее сервисный контент охватывает закупку, продажу, логистику и распределение автомобильных аксессуаров, техническую поддержку и эксплуатацию платформы и другие аспекты, для автомобильной промышленности, чтобы предоставить полный спектр, единые решения цепочки поставок.",
    "汽车售后产业平台，提供一站式服务支持": "Постпродажная платформа для автомобильной промышленности, обеспечивающая поддержку единого сервиса",
    "汽车配件在线交易平台": "Платформа онлайн - торговли автомобильными аксессуарами",
    "汽配商": "Парораспределитель",
    "沃尔沃": "Вольво!",
    "沃玛拉国际贸易有限公司": "& lt; & lt; Уомара интернэшнл трейдинг лтд. & gt; & gt;",
    "油品": "Нефтепродукты",
    "油品1": "Нефтепродукты 1",
    "注册": "Регистрация",
    "注册公司名称": "Наименование зарегистрированной компании",
    "注册成功！": "Регистрация успешна!",
    "注册时间": "Регистрация",
    "注释": "Примечания",
    "活跃用户": "Активные пользователи",
    "测试中心": "Испытательный центр",
    "添加": "Добавить",
    "添加人员": "Добавление персонала",
    "添加商品": "Добавить товар",
    "添加成功": "Добавить успех",
    "添加抬头": "Добавить заголовок",
    "温馨提示": "Теплый совет",
    "点击打开小程序支付": "Нажмите, чтобы открыть небольшую программу для оплаты",
    "点击打开网页支付": "Открыть страницу для оплаты",
    "点击查看价格": "Нажмите, чтобы посмотреть цены",
    "点火系统": "Система зажигания",
    "热销商品": "Горячие товары",
    "热门商品": "Горячие товары",
    "照明系统": "Система освещения",
    "燃油供给系": "Система подачи топлива",
    "燃油类型": "Тип топлива",
    "物流": "Логистика",
    "物流单号": "Логистический номер",
    "物流名称": "Название логистики",
    "特价专区": "Специальная зона",
    "特价商品": "Специальные товары",
    "状态": "состоян",
    "玛莎拉蒂": "мазерати",
    "现有货源充足，小订单交货期1周以内，普通订单交货期15天左右，定制订单交货期1-2个月。": "В наличии достаточно товаров, срок поставки малых заказов - в течение 1 недели, обычных заказов - около 15 дней, индивидуальных заказов - 1-2 месяца.",
    "现货": "Наличные товары",
    "现货充足": "Достаточно наличных.",
    "现货紧张": "Стресс спот",
    "现金": "Наличные средства",
    "生成催收单": "Формирование квитанции",
    "用户": "Пользователи",
    "用户列表": "Список пользователей",
    "用户名": "Имя пользователя",
    "用户名称": "Имя пользователя",
    "用户状态": "Статус пользователя",
    "用户管理": "Управление пользователями",
    "申请人姓名": "Имя заявителя",
    "申请售后": "Заявка после продажи",
    "申请时间": "Время подачи заявки",
    "申请金额": "Сумма заявки",
    "电气系统": "Электрическая система",
    "电话": "Телефон",
    "电话号码": "Номер телефона",
    "疑问解答": "Ответы на вопросы",
    "登录": "Регистрация",
    "直接定价": "Прямое ценообразование",
    "直接替换": "Прямая замена",
    "省/市/区": "область/город/район",
    "省市区": "Провинциальные районы",
    "知名品牌": "Известные марки",
    "确定": "Определение",
    "确定收货": "Определение получения",
    "确定要修改吗？": "Вы уверены, что хотите изменить?",
    "确认": "Подтверждение",
    "确认下单": "Подтвердить заказ",
    "确认付款": "Подтверждение платежа",
    "确认删除?": "Подтвердить удаление?",
    "确认删除订单?": "Подтвердить удаление заказа?",
    "确认密码": "Подтвердить пароль",
    "确认支付": "Подтверждение платежа",
    "确认收货": "Подтверждение получения",
    "确认解绑": "Подтверждаю. Освободи.",
    "确认购买": "Подтверждение покупки",
    "禁用": "Деактивация",
    "离合器泵类": "Насосы сцепления",
    "积分兑换区": "зона интегрального обмена",
    "积分商城": "Интегрированный торговый центр",
    "税号": "Номер налога",
    "税点": "Налоговый пункт",
    "税额": "Налоги",
    "税额设置": "Налоговый режим",
    "空": "пуст",
    "空调系统": "Kондиционер",
    "空闲": "свободн",
    "立即购买": "Купить сразу",
    "管": "Трубка",
    "管理员": "Администратор",
    "管理收货地址": "Управление адресами получения",
    "管路总成类": "Категория трубопроводов",
    "米": "метр",
    "类型": "тип",
    "粘贴信息、自动拆分姓名、电话和地址": "Вставка информации, автоматическое разделение имени, телефона и адреса",
    "粘贴信息，自动拆分姓名、电话和地址": "Вставьте информацию, автоматически разделяя имя, телефон и адрес",
    "粘贴并识别": "Вставить и распознать",
    "粘贴或拖动文件到此区域以进行识别": "Вставить или перетащить файл в эту область для идентификации",
    "系统标签": "Системные метки",
    "系统预置": "Предустановка системы",
    "繁忙": "Занятость",
    "纳税人识别号": "Идентификатор налогоплательщика",
    "线上已支付": "Онлайн оплата.",
    "线下已支付": "В оффлайне оплачены",
    "线下已支付待确认": "Подтверждена оплата.",
    "线下门店": "Линейный магазин",
    "组": "групп",
    "绑定关系": "Связанные отношения",
    "结算": "расчетн",
    "维修保养件": "Ремонтно - эксплуатационные детали",
    "维修方案": "Программа технического обслуживания",
    "编号查询": "Поиск по номеру",
    "编辑": "Редактирование",
    "编辑岗位": "Редактирование должностей",
    "编辑机洗规则": "Изменить правила стирки",
    "编辑标签": "Изменить вкладку",
    "编辑模版": "Изменить шаблон",
    "老板": "Босс!",
    "耐博德": "Нейбод",
    "联系人": "Контактные лица",
    "联系我们": "Свяжитесь с нами",
    "联系电话": "Контактный телефон",
    "自动通过": "Автоматическое прохождение",
    "自定义": "Настройка",
    "自定义替换OE": "Настройка замены OE",
    "自定义替换OE编辑成功！": "Настройка замены OE успешно!",
    "自定义替换件": "Настройка замены",
    "自定义标签": "Настройка меток",
    "自定义配件": "Настройка аксессуаров",
    "自营产品": "Самостоятельная продукция",
    "英文": "Английский",
    "获取价格": "Получение цены",
    "获取验证码": "Получение кода проверки",
    "营业员": "Оператор",
    "营业执照": "Лицензия",
    "萨肯SHAKOLN，专注于研发和销售高性能的汽车零部件。": "Компания Saken Shakoln специализируется на разработке и продаже высокопроизводительных автомобильных деталей.",
    "行驶系统": "Система движения",
    "解放": "Освобождение",
    "解析错误，请上传清晰图片！": "Анализируйте ошибки, пожалуйста, загрузите четкое изображение!",
    "解绑": "Освободите.",
    "解绑后，将不再是公司成员！": "После освобождения он больше не будет членом компании!",
    "计划金额 (万)": "Запланированная сумма (млн.)",
    "订单": "заказать",
    "订单信息": "Информация о заказе",
    "订单分配": "Распределение заказов",
    "订单列表": "Список заказов",
    "订单号": "Номер заказа",
    "订单号/VIN码搜索": "Поиск по номеру заказа / VIN-коду",
    "订单回写中，请等待": "Заказ на обратную запись, пожалуйста, подождите",
    "订单备注": "Примечания к заказам",
    "订单数": "Количество заказов",
    "订单数量": "Количество заказов",
    "订单管理": "Управление заказами",
    "订单详情": "Подробности заказа",
    "订单金额": "Сумма заказа",
    "认证中": "Сертификация в",
    "认证公司名称": "Наименование сертифицированной компании",
    "认证公司后显示价格": "Показать цены после сертификации",
    "认证后可获得更多，商品查询次数": "После сертификации можно получить больше, количество запросов на товары",
    "认证失败": "Ошибка аутентификации",
    "认证状态": "Статус аутентификации",
    "认领": "Признание",
    "让配件交易更简单": "Сделать торговлю аксессуарами проще",
    "让配件查询更简单": "Сделать поиск аксессуаров проще",
    "设为默认": "Установить по умолчанию",
    "设备": "Оснащение",
    "设备1": "Оборудование 1",
    "设置": "Set",
    "设置为收货地址": "Установить адрес получения",
    "设置为默认发票": "Установить счет - фактуру по умолчанию",
    "设置为默认收货地址": "Адрес получения по умолчанию",
    "译码": "Декодирование",
    "译码列表": "Список расшифровок",
    "译码员": "Переводчик",
    "译码时间": "Время декодирования",
    "试装过": "Испытал.",
    "诚邀全国合作代理商": "Приглашаем национальных партнеров",
    "询价": "Запрос цены",
    "询价人": "Запрос",
    "询价列表": "Список запросов",
    "询价成功": "Запрос успешно",
    "询价成功，可在订单列表中查看！": "Запрос выполнен, его можно посмотреть в списке заказов!",
    "该公司已存在，您将自动申请加入此公司": "Компания уже существует, и вы автоматически подадите заявку на вступление в эту компанию.",
    "该商品尚未定价": "Товар еще не оценен",
    "该日期内已有生成的催收单，将无法生成可取消或客户付款后再生成！": "Обращение, которое было создано в течение этой даты, не будет генерироваться для отмены или после оплаты клиентом!",
    "该日期内已有生成的催收单，请先取消或客户付款后再生成！": "Обращение, которое было создано в течение этой даты, пожалуйста, отмените или оплатите клиент, прежде чем оно будет создано!",
    "该用户曾绑定多家公司": "Пользователь связал несколько компаний.",
    "详情": "Подробности",
    "详细信息": "Подробная информация",
    "详细地址": "Подробный адрес",
    "说明": "Руководство",
    "请使用微信扫一扫": "Пожалуйста, используйте микрофон.",
    "请使用微信扫一扫，扫描二维码支付": "Пожалуйста, используйте WeChat для сканирования QR-кода и оплаты",
    "请使用零零汽APP扫码登录": "Пожалуйста, войдите в систему с помощью программы нулевой загрузки.",
    "请先填写内容": "Сначала заполните содержимое.",
    "请先填写必填信息!": "Пожалуйста, заполните необходимую информацию!",
    "请先点击同意《用户注册协议》和《用户隐私协议》再注册！": "Пожалуйста, сначала нажмите согласие на Соглашение о регистрации пользователя и Соглашение о конфиденциальности пользователя, прежде чем зарегистрироваться!",
    "请先点击同意《用户注册协议》和《用户隐私协议》再登录！": "Пожалуйста, сначала нажмите согласие на Соглашение о регистрации пользователя и Соглашение о конфиденциальности пользователя, прежде чем войти в систему!",
    "请先登录": "Пожалуйста, войдите.",
    "请先输入手机号!": "Пожалуйста, сначала введите номер телефона!",
    "请先输入邮箱!": "Пожалуйста, сначала введите свой электронный адрес!",
    "请填写件数": "Пожалуйста, заполните количество",
    "请填写发货单备注": "Пожалуйста, заполните накладную.",
    "请填写物流单号": "Пожалуйста, заполните список.",
    "请填写物流名称": "Пожалуйста, заполните логин.",
    "请填写物流备注": "Пожалуйста, заполните логистические заметки.",
    "请填写送货骑手姓名": "Заполните имя всадника доставки.",
    "请最少选择一个商品发货！": "Пожалуйста, выберите хотя бы один товар!",
    "请最少选择一项！": "Пожалуйста, выберите хотя бы один!",
    "请正确填写参数": "Заполните параметры правильно.",
    "请添加发票": "Пожалуйста, добавьте счет.",
    "请添加商品到购物车": "Пожалуйста, добавьте товар в корзину.",
    "请登录": "Пожалуйста, войдите",
    "请确认 ERP 系统用户名": "Подтвердите имя пользователя ERP - системы",
    "请确认删除?": "Подтвердите удаление?",
    "请确认收货": "Подтвердите получение.",
    "请认证公司，获取查询次数！": "Пожалуйста, сертифицируйте компанию, чтобы получить количество запросов!",
    "请输入": "Введите",
    "请输入OE或厂家编码": "Введите код OE или производителя.",
    "请输入VIN码": "Введите VIN - код.",
    "请输入VIN码或拖拽VIN码图片到此处": "Введите VIN - код или перетащите изображение VIN - кода сюда.",
    "请输入oe": "Введите OE",
    "请输入公司税号": "Введите налоговый номер компании.",
    "请输入发件人姓名": "Введите имя отправителя",
    "请输入发件人联系方式": "Введите контактную информацию отправителя",
    "请输入发件人详细地址": "Введите подробный адрес отправителя",
    "请输入增值税专用发票点数": "Пожалуйста, введите счет - фактуру по НДС.",
    "请输入备注": "Пожалуйста, введите примечание",
    "请输入备注内容": "Введите заметки.",
    "请输入完整的收发货信息！": "Пожалуйста, введите полную информацию о доставке!",
    "请输入客户ID": "Введите идентификатор клиента",
    "请输入客户名字或者简拼": "Введите имя клиента или просто напишите.",
    "请输入客户名称": "Введите имя клиента",
    "请输入抬头名称": "Введите имя заголовка",
    "请输入授信金额": "Введите сумму",
    "请输入授信金额(￥)": "Введите, пожалуйста, сумму кредита (￥)",
    "请输入收件人姓名": "Введите имя получателя",
    "请输入收件人联系方式": "Введите контактные данные получателя",
    "请输入收件人详细地址": "Введите подробный адрес получателя",
    "请输入数值": "Введите значение",
    "请输入普通发票开票点数": "Введите счет - фактуру, пожалуйста.",
    "请输入材质": "Пожалуйста, введите материал.",
    "请输入模版名称": "Введите имя шаблона",
    "请输入正确的数字并保留两位小数": "Введите правильную цифру и сохраните две десятичные дроби.",
    "请输入物流名称！": "Введите название логистики!",
    "请输入纳税人识别号": "Введите номер налогоплательщика.",
    "请输入联系人": "Введите контакт",
    "请输入联系电话": "Пожалуйста, введите контактный телефон.",
    "请输入详细地址": "Введите подробный адрес",
    "请输入详细地址信息，如道路、门牌号等信息": "Пожалуйста, введите подробную информацию об адресе, такую как улица, номер дома и т.д.",
    "请输入送货骑手联系方式": "Введите контактную информацию всадника доставки.",
    "请输入零件号查询，多零件请换行": "Введите номер детали для поиска, для нескольких деталей введите каждую с новой строки",
    "请输入零件名称或零件号": "Введите имя или номер детали",
    "请输入需要添加的标签": "Введите вкладку, которую необходимо добавить",
    "请选择": "Выберите",
    "请选择 ERP 系统用户名": "Выберите имя пользователя ERP",
    "请选择仓库": "Выберите склад",
    "请选择价格模版": "Выберите шаблон цены",
    "请选择公司": "Пожалуйста, выберите компанию",
    "请选择地址": "Выберите адрес",
    "请选择基础模版": "Выберите базовый шаблон",
    "请选择客户": "Пожалуйста, выберите клиента.",
    "请选择客户类型": "Выберите тип клиента",
    "请选择开具发票信息": "Пожалуйста, выберите выписку счета.",
    "请选择或者输入必填项！": "Пожалуйста, выберите или введите обязательную запись!",
    "请选择支付方式": "Пожалуйста, выберите способ оплаты.",
    "请选择收货地址": "Пожалуйста, выберите адрес получения",
    "请选择需要购买的商品": "Пожалуйста, выберите товары, которые нужно купить.",
    "调比例": "Корректировка масштаба",
    "账号": "Номер счета",
    "账号/公司/标签": "Счет / компания / этикетка",
    "账号/公司名称": "Номер счета / название компании",
    "账号/公司搜索": "Поиск аккаунта / компании",
    "账号状态": "Состояние счета",
    "账户余额": "Сальдо счета",
    "货到付款": "Платежи по прибытии товаров",
    "货款": "Плата за товары",
    "货款已结算": "Платежи за товар оплачены",
    "货款未结算": "Неоплаченные товары",
    "货款状态": "Состояние оплаты",
    "质保": "Гарантия качества",
    "质保政策": "Политика обеспечения качества",
    "质保时间": "Время гарантии качества",
    "质保时间管理": "Управление временем обеспечения качества",
    "购买数量：": "Количество покупок",
    "购买流程": "Процесс покупки",
    "购物车": "Тележка для покупок",
    "购货单位": "Закупающая организация",
    "购货收货人": "Покупатель",
    "购货日期": "Дата покупки",
    "起订量": "Количество заказов",
    "距离二维码过期还剩x秒，过期后请刷新页面重新获取二维码": "До истечения срока действия QR-кода осталось x секунд, после истечения обновите страницу, чтобы получить QR-код заново.",
    "路虎捷豹": "LandRover Jaguar",
    "跳过": "Пропустить",
    "车型": "Модель",
    "车型(底盘)": "Модель (шасси)",
    "车型查询": "Поиск модели автомобиля",
    "车架号查询": "Запрос номера машины",
    "车润保是一家专注于整合配件商与修理厂的汽车配件交易平台公司。我们的使命是为汽车维修行业提供高效、便捷的配件采购和交易解决方案。 作为汽车配件交易平台，我们与全国各地的优秀配件供应商、配件生产厂家建立了紧密的合作关系。通过我们的平台，修理厂可以轻松浏览和购买各类汽车配件，包括The engine零件、制动系统、悬挂部件、电子设备等。我们提供多样化的产品选择，以满足不同车型和维修需求。": "Car Runbao - это торговая платформа для автомобильных аксессуаров, ориентированная на интеграцию производителей аксессуаров и ремонтных мастерских. Наша миссия - предоставить эффективные и удобные решения для покупки аксессуаров и торговли ими для автомобильной промышленности. Как торговая платформа для автомобильных аксессуаров, мы установили тесное сотрудничество с выдающимися поставщиками аксессуаров и производителями аксессуаров по всей стране. С помощью нашей платформы ремонтные мастерские могут легко просматривать и покупать различные автомобильные аксессуары, включая детали The Engine, тормозные системы, детали подвески, электронные устройства и так далее. Мы предлагаем разнообразный выбор продукции для удовлетворения различных потребностей в моделях и обслуживании.",
    "车身": "Кузов",
    "车辆信息": "Информация о транспортных средствах",
    "车辆确认": "Подтверждение автотранспортных средств",
    "转向系统": "Рулевое управление",
    "转向节总成类": "Категория рулевого узла",
    "转让后，该账号将成为店长！": "После передачи аккаунт становится директором магазина!",
    "转让管理员": "Управляющий передачей",
    "输入OE号或17位车架号(支持拖拽或粘贴图片识别)": "Введите номер OE или 17 - битный номер рамы (с поддержкой перетаскивания или вставки изображения)",
    "输入VIN码，快速查询零件": "Введите VIN - код, быстро проверьте детали",
    "输入公司名称": "Введите название компании",
    "输入内容…": "Введите содержимое...",
    "输入名称": "Введите имя",
    "输入商品名称/编码": "Введите название / код товара",
    "输入备注": "Введите примечание",
    "输入奔驰后8位或17位车架号": "Введите 8 - или 17 - битный номер машины после Mercedes.",
    "输入宝马后7位或17位车架号": "Введите 7 - или 17 - битный номер рамы BMW.",
    "输入岗位名称": "Введите название должности",
    "输入手机号": "Введите номер телефона.",
    "输入拒绝理由": "Причины отказа",
    "输入标签名称": "Введите имя метки",
    "输入玛莎拉蒂后7位或17位车架号": "Введите 7 - или 17 - битный номер рамы Maserati.",
    "输入用户名称或账号": "Введите имя пользователя или учетную запись",
    "输入申请人姓名": "Введите имя заявителя",
    "输入税号": "Введите налоговый номер",
    "输入街道、门牌号、写字楼、商圈": "Введите улицы, номера домов, офисные здания, торговые круги",
    "输入解放后8位或17位车架号": "Введите 8 - или 17 - значный номер рамы после освобождения.",
    "输入账号/名称搜索": "Введите номер счета / имя для поиска",
    "输入账号/姓名搜索": "Введите номер счета / имя для поиска",
    "输入路虎捷豹后8位或17位车架号": "Введите номер рамы LandRover Jaguar 8 или 17 бит.",
    "输入重汽后8位或17位车架号": "Введите 8 - или 17 - разрядный номер рамы.",
    "输入金额": "Сумма импорта",
    "输入陕汽后8位或17位车架号": "Введите 8 - разрядный или 17 - разрядный номер автомобиля.",
    "输入零件原厂名／零件号": "Введите оригинальное наименование / номер детали",
    "过滤": "Фильтр",
    "迈巴赫专区": "Майбах (округ)",
    "返回": "Назад",
    "返回商城登录": "Вернуться в Торговый центр",
    "返回搜索": "Вернуться в Поиск",
    "返回登录": "Вернуться в Регистрация",
    "返回首页": "Вернуться на главную страницу",
    "返点比例": "Соотношение точек возврата",
    "返点金额 (万)": "Сумма возврата (млн.)",
    "进价(含税)": "Поступления (включая налоги)",
    "进价(未含税)": "Прибыльная цена (без учета налогов)",
    "进口品牌": "Импортные марки",
    "进货价(含税)": "Входная цена (включая налоги)",
    "退出": "Завершить",
    "退出登录": "Выход из системы",
    "退款": "Возврат средств",
    "退款/售后": "Возврат / после продажи",
    "退款金额": "Сумма возмещения",
    "退货退款": "Возврат",
    "送及经手人": "Отправитель и оператор",
    "送货骑手": "Доставка всадников",
    "适用OE": "Применение OE",
    "适用车型": "Пригодный тип автомобиля",
    "适配OE": "Подходит OE",
    "适配车型": "Подходящие модели",
    "选择": "Выбор",
    "选择价格类型": "Выберите тип цены",
    "选择品牌": "Выберите марку",
    "选择商户": "Выбор продавца",
    "选择图像": "Выберите изображение",
    "选择岗位": "Выбор должности",
    "选择年份": "Выбрать год",
    "选择排量": "Выберите количество",
    "选择省/市/区": "Выбор провинции / города / района",
    "选择类型": "Выбор типа",
    "选择要查询的内容": "Выберите содержимое запроса",
    "选择账号": "Выберите номер счета",
    "选择车型": "Выберите модель",
    "选择配置信息": "Выбор информации о конфигурации",
    "邮箱": "Почтовый ящик",
    "部分发货": "Частичная отгрузка",
    "配件品牌": "Марки запчастей",
    "配件总成类": "Запасные части в сборе",
    "配置": "конфигурац",
    "配置详情": "Настройка деталей",
    "配送方式": "Способ доставки",
    "采埃孚": "Цефер",
    "采购商": "Покупатель",
    "采购款": "Закупки",
    "采购款已结算": "Покупки оплачены",
    "采购款未结算": "Неоплаченные закупки",
    "采购款状态": "Статус закупочной деятельности",
    "重": "тяжел",
    "重新上传": "Перезагрузить",
    "重新申请": "Повторное заявление",
    "重汽": "Тяжелый пар",
    "金额": "Сумма",
    "银行账户": "Банковские счета",
    "销售价": "Продажная цена",
    "销售价(含税)": "Продажная цена (включая налоги)",
    "销售清单": "Список продаж",
    "锁定": "Блокировка",
    "锁定上下架状态?": "Заблокировать верхнюю и нижнюю стойки?",
    "锁定上架状态?": "Заблокировать состояние на полке?",
    "锁定下架状态?": "Заблокировать состояние?",
    "长": "длинный",
    "长度不超过25个字符": "Длина не более 25 символов.",
    "门店照片": "Фотографии магазина",
    "间接替换": "Косвенная замена",
    "陕汽": "Шэньси",
    "雨刮": "Дожд поцарапа",
    "雨刮系统": "Дождевая система",
    "零件": "Деталь",
    "零件信息": "Информация о деталях",
    "零件分类": "Классификация деталей",
    "零件参数": "Параметры деталей",
    "零件号查询": "Запрос на номер запчасти",
    "零件名": "Название запчасти",
    "零件名称": "Название запчасти",
    "零件名称/OE": "Название деталей / OE",
    "零件图": "График деталей",
    "零件类型：": "Тип деталей",
    "零件识别": "Идентификация деталей",
    "零零汽APP扫码登录": "Запись нулевого пароля",
    "零零汽二维码登录": "QR - код нулевого пара",
    "零零汽账号": "Нулевой счет.",
    "零零汽账号登录": "Зарегистрируйте нулевой счет",
    "非危险品": "Неопасные грузы",
    "非易碎品": "Неразрушающийся продукт",
    "预计购买后3-7个工作日发货": "Поставка ожидается через 3 - 7 рабочих дней после покупки",
    "风险": "Риск",
    "风险用户提示": "Настройка пользователя риска",
    "驱动": "привод",
    "驱动方式": "Тип привода",
    "驾安配": "Ваше здоровье",
    "验证码": "Код проверки",
    "验证码登录": "Код проверки",
    "高": "Высокий",
    "高质量货源，全平台覆盖，自带销量": "Высококачественный источник товаров, покрытие всех платформ, встроенные продажи",
    "默认": "По умолчанию",
    "鼓式制动器": "Барабанные тормоза",
    "下单成功": "Заказ удался.",
    "浏览记录": "Браузера",
    "共{count}家店": "Всего {count} магазина"
    
  }
}

export default ru